import ADPRefcodeService from "../../../services/admin/ADPRefcodeService";

class samplePageService {

    async getClientState(): Promise<any> {
        const clientState = localStorage.getItem('clientState');
        return clientState ? JSON.parse(clientState) : null
    }

    async findAllDonor(recordFilter: any): Promise<any> {
        return null;
    }

    async getGenderDropdown(moduleId: string, referenceGroup: string): Promise<any> {
        return await ADPRefcodeService.getDropdownByModuleIdAndReferencegroup(moduleId, referenceGroup);
    }

    async getDropdown(moduleId: string, referenceGroup: string): Promise<any> {
        return await ADPRefcodeService.getDropdownByModuleIdAndReferencegroup(moduleId, referenceGroup);
    }


    async create(item: any): Promise<any> {
        return null;
    }

    async update(item: any): Promise<any> {
        return null;
    }

}

export default new samplePageService();
